export default __webpack_public_path__ + "static/media/CSS_-_adamr.space___Codecademy.c394b3dc.pdf";